<template>
  <v-expansion-panels v-model="panel" :flat="flat" class="mb-4">
    <v-expansion-panel class="rounded-lg" :elevation="0">
      <v-expansion-panel-header class="grey--text text--darken-1">
        <span><v-icon>mdi-filter-outline</v-icon> {{ defaultTitle }}</span>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <slot />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { displayHelpers } from "@/mixins/breakpoints.mixins";
export default {
  name: "ExpansionPanelFilters",
  mixins: [displayHelpers],
  props: {
    title: {
      type: String,
      default: "",
    },
    flat: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      panel: 0,
    };
  },
  computed: {
    defaultTitle() {
      return this.title ? this.title : this.$t("common.filters");
    },
  },
  watch: {
    smAndDown() {
      this.panel = this.smAndDown ? null : 0;
    },
  },
  mounted() {
    this.panel = this.smAndDown ? null : 0;
  },
};
</script>

<style lang="scss" scoped></style>
